import { Box } from 'braid-design-system';
import React, { type ReactNode } from 'react';

import * as styles from './style.css';

interface Props {
  children: ReactNode;
  htag?: string;
  onClick: () => void;
}

const ButtonWrapper = ({ children, htag, onClick }: Props) => (
  <Box
    className={styles.buttonBehaviour}
    data-htag={htag}
    onClick={onClick}
    role="button"
  >
    {children}
  </Box>
);

export default ButtonWrapper;
